import {congregationRoleConsts} from "../../const";

export function congregationRoles (state = {}, action) {
  switch (action.type) {
    case congregationRoleConsts.LOAD_REQUEST:
      return {
        ...state,
        loading: true
      };
    case congregationRoleConsts.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.congregationRoles
      };
    case congregationRoleConsts.LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };

    default:
      return state;
  }
}
